import { ComponentType, FC, HTMLAttributes, memo, ReactNode, SVGAttributes, useMemo } from 'react';

import useClientState from '@/state/useClientState';

import { ActionKey } from '../../types/Actions';

import styles from '@/components/contextMenu/ContextMenu.module.css';

type ActionLinkProps = HTMLAttributes<HTMLLIElement> & {
  actionKey: ActionKey;
  icon: ComponentType<SVGAttributes<SVGSVGElement>>;
  children: ReactNode | ReactNode[];
  shortcut?: string;
};

const ActionLink: FC<ActionLinkProps> = ({ actionKey, icon: Icon, children, shortcut, ...listItemProps }) => {
  const setShowDialog = useClientState((state) => state.setShowDialog);
  const colorValue = useMemo(
    () =>
      ['verwijder-claim', 'multi-verzwakken', 'inzet-verzwakken', 'inregeling-verwijderen'].includes(actionKey)
        ? 'var(--tractie-color-content-destructive-default)'
        : 'var(--tractie-color-content-emphasis)',
    [actionKey],
  );

  return (
    <li
      data-testid={actionKey}
      className={styles.contextInnerMenuListItem}
      style={{ color: colorValue }}
      onClick={() => {
        void setShowDialog(actionKey);
      }}
      {...listItemProps}
    >
      <div className={styles.contentWrapper}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {Icon && <Icon aria-hidden='true' width='22px' height='22px' fill={colorValue} />}
          <span>{children}</span>
        </div>
        {shortcut && <span className={styles.shortcut}>{shortcut}</span>}
      </div>
    </li>
  );
};

export default memo(ActionLink);
